module.exports = __webpack_public_path__ + "static/media/contact_blur.0ab2222a.jpg";